import dataJson from "@/../public/data.json";

import "./index.less";

const prefix = "design-guideline";

function DesignGuideline() {
  return (
    <div className={prefix} style={{backgroundImage:`url(${dataJson.design.design_guideline_bg})`}}>
      <div className={`${prefix}-inner`}>
        <div className={`${prefix}-title`}>{dataJson.design.design_guideline_title}</div>
      </div>
    </div>
  );
}

export default DesignGuideline;
